export const readImageFile = (img: string, defaultImage?: string) => {
  if (!img) return defaultImage

  return [process.env.REACT_APP_MEDIA_URL, img].join("")
}
export const readImageFileFromCore = (img: string, defaultImage?: string) => {
  if (!img) return defaultImage

  return [process.env.CORE_MEDIA_URL, img].join("")
}